export default {
  allVariants: {
    fontFamily: 'Roboto',
  },
  h1: {
    fontWeight: 600,
    fontSize: '2rem',
    lineHeight: 1.8,
  },
  h2: {
    fontWeight: 600,
    fontSize: '1.4rem',
    lineHeight: 1.2,
  },
  h3: {
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.125,
  },
  h4: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.25,
  },
  h5: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.25,
  },
  h6: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.25,
  },
  subtitle1: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1,
  },
  subtitle2: {
    fontWeight: 400,
    fontSize: '0.625rem',
    lineHeight: 1,
  },
  body1: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.2,
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 0.875,
  },
  button: {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.25,
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.3,
  },
  overline: {},
};
